import { cn } from "@/lib/utils";
import {
  deskSegmentItemClass,
  deskSegmentListClass,
  deskSegmentNavClass,
} from "./desk-segment";

export type DeskDocTab = {
  id: string;
  label: string;
  /** Optional count shown as “Label (n)” when > 0 */
  count?: number;
};

/** In-page related views of one doc — plan/35 doc related tabs. */
export function DeskDocTabs(props: {
  items: readonly DeskDocTab[];
  value: string;
  onChange: (id: string) => void;
  className?: string;
  "aria-label"?: string;
}) {
  const items = props.items;
  if (items.length === 0) return null;

  return (
    <nav
      aria-label={props["aria-label"] ?? "Document views"}
      className={deskSegmentNavClass(props.className)}
    >
      <div className={deskSegmentListClass()} role="tablist">
        {items.map((item) => {
          const active = item.id === props.value;
          const label =
            item.count != null && item.count > 0
              ? `${item.label} (${item.count})`
              : item.label;
          return (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={active}
              className={cn(deskSegmentItemClass(active), "border-0 bg-transparent")}
              onClick={() => props.onChange(item.id)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
